const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export async function getAll(filters = {}) {
    const query = new URLSearchParams();

    if (filters.name) {
        query.append('name', filters.name);
    }
    
    const queryString = query.toString();
    const url = queryString 
    ? `${BASE_URL}/api/configuration/documentTypes?${queryString}`
    : `${BASE_URL}/api/configuration/documentTypes`

    const res = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    const text = await res.text();

    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = null;
    }

    if (!res.ok) {
        throw new Error(`Failed to fetch users: ${res.status}`);
    }

    return { status: res.status, ok: res.ok, data };
}